export { getDisplayName as default } from "./getDisplayName";
